module.exports = __webpack_public_path__ + "img/gyermektamogatas-1.762898f3.jpg";